import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceRouter from "@/pages/ServiceRouter";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Pricing from "@/pages/Pricing";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import BookAudit from "@/pages/BookAudit";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import StubPage from "@/pages/StubPage";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceRouter />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/book-audit" element={<BookAudit />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/privacy"
            element={
              <StubPage
                testId="privacy-page"
                eyebrow="Privacy"
                title="Privacy Policy"
                description="We respect your data. EchoWings Media only collects information you submit through our forms and uses it solely to provide the services you request. We never sell or share personal data with third parties."
              />
            }
          />
          <Route
            path="/terms"
            element={
              <StubPage
                testId="terms-page"
                eyebrow="Terms"
                title="Terms of Service"
                description="By engaging with EchoWings Media, you agree to our scope-of-work, fair-use, intellectual property and confidentiality terms. Full client agreements are provided in writing at project kickoff."
              />
            }
          />
          <Route
            path="*"
            element={
              <StubPage
                testId="not-found-page"
                eyebrow="404"
                title="Page not found."
                description="The page you're looking for doesn't exist — yet. Head back to the home page or book a free audit to get started."
              />
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(18,18,18,0.95)",
            border: "1px solid rgba(0,229,255,0.25)",
            color: "#fff",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </div>
  );
}

export default App;
